module.exports = __webpack_public_path__ + "img/gold-medal.26312d58.png";